export default "__VITE_ASSET__CpoR4$y7__"